import 'twin.macro';
import 'styled-components/macro';
import { useFormik } from 'formik';
import { FC } from 'react';
import { number, object, string } from 'yup';

import { ButtonV2 } from 'component-lib/atoms/button-v2/ButtonV2';
import { Input } from 'component-lib/atoms/controls/Input';
import { TextArea } from 'component-lib/atoms/controls/TextArea';
import { Rating } from 'toy/atoms/rating/Rating';

interface ReviewFormValues {
  author: string;
  rating: number | null;
  text: string;
}

interface ReviewFormProps {
  onSubmit: (review: ReviewFormValues) => void;
}

export const ReviewForm: FC<ReviewFormProps> = ({ onSubmit }) => {
  const { getFieldProps, getFieldMeta, setFieldValue, handleSubmit, isValid } = useFormik<ReviewFormValues>({
    initialValues: {
      author: '',
      rating: null,
      text: '',
    },
    validationSchema: object({
      author: string().required().min(2),
      rating: number().typeError('Rating is required'),
      text: string().required().min(2),
    }),
    onSubmit(review) {
      onSubmit(review);
    },
  });

  return (
    <form tw="min-w-[445px] rounded-sm border-1 p-3 bg-white rounded-b-sm" onSubmit={handleSubmit}>
      <div tw="flex flex-col gap-3">
        <div tw="flex justify-between items-center">
          <div tw="min-w-[260px]">
            <Input {...getFieldProps('author')} {...getFieldMeta('author')} label="Name" tw="max-w-[250px]" />
          </div>

          <Rating
            {...getFieldMeta('rating')}
            {...getFieldProps('rating')}
            disabled={false}
            label="Rate"
            onChange={val => {
              setFieldValue('rating', val);
            }}
          />
        </div>

        <TextArea {...getFieldProps('text')} {...getFieldMeta('text')} label="Write a Comment" />
      </div>

      <ButtonV2 tw="mt-[20px]" variant="primary" type="submit" disabled={!isValid}>
        Leave comment
      </ButtonV2>
    </form>
  );
};
